import { Badge } from 'components/atoms/Badge';
import { Icon } from 'components/atoms/Icon';
import { localize } from 'i18n/localize.ts';

const $t = localize();

export function VideoBadge() {
	return (
		<Badge type="dark-blue-transparent" className="gap-x-0.5 px-1.5 @cardLg:pl-3">
			<span class="hidden @cardLg:inline">{$t.offer.stateVideo}</span> <Icon type="play_circle" size={24} />
		</Badge>
	);
}
